import { render, staticRenderFns } from "./zendesk-loader.vue?vue&type=template&id=2698967a&scoped=true&"
import script from "./zendesk-loader.ts?vue&type=script&lang=ts&"
export * from "./zendesk-loader.ts?vue&type=script&lang=ts&"
import style0 from "./zendesk-loader.scss?vue&type=style&index=0&id=2698967a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2698967a",
  null
  
)

component.options.__file = "zendesk-loader.vue"
export default component.exports